import MealPlanner from '../components/MealPlanner';

const Meals = () => (
  <div>
    <MealPlanner />
  </div>
);

export default Meals;
